import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { TitleRow, ContainerRow, CloseButton } from '../styledComponents';
import CustomTypography from '../../CustomComponents/CustomTypography';
import { NavTabs, NavTab } from '../TemplateList/styledComponents';
import { useSelector } from 'react-redux';
import PageTitle from '../../../Utils/PageTitle';

import { SEARCH_DELAY } from '../../../Constants/StringConstants';

import AddKeyToPhraseForm from './AddKeyToPhraseForm';
import KeyToPhraseDetailPanel from './KeyToPhraseDetailPanel';
import { notifyNotEditable } from './notifyNotEditable';
import CustomSideDrawer from '../../CustomComponents/CustomSideDrawer';

import {
  saveCannedText,
  getAllCannedText,
  saveCannedTextActiveList,
  removeCannedTextActiveList,
  authorsCollectionToMyCollection,
  editCannedText,
  exportedCannedText,
  removeCannedTexts,
  templateMappingStatus,
  targetEndPoints,
  listDictationTemplate
} from '../../../Apis/Author';
import {
  notification,
  Row,
  Col,
  Checkbox,
  message,
  Button,
  Divider,
  Tooltip,
  Tag,
  Segmented
} from 'antd';
import {
  SearchOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
  ArrowDownOutlined,
  DownloadOutlined,
  EditOutlined
} from '@ant-design/icons';

import DeleteIcon from '../../../Assets/Icons/DeleteIcon';
import { useDebounce } from '../../../Utils/Debounce';
import { AddButton } from '../styledComponents';
import {
  SubmitCol,
  KpCol,
  ActiveKeytophraseCol,
  CardTitle,
  StyledSelect,
  StyledDiv,
  DnDColumn,
  CustomModal,
  Keytophraseduplication,
  K2pButton,
  Topdivide,
  K2pButtonsecnd,
  ActiveSectionCol,
  SearchInputStylee,
  KeytophraseMineCol,
  SearchDivider,
  CustomModalforAddk2p,
  StatusSwitch
} from './styledComponents';
import { SearchInputStyle } from '../styledComponents';
import { DeleteConfirmationMessage } from '../Dictation/styledComponents';
import { getUserFacilities } from '../../../Apis/User';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { COLUMN_NAMES, Column, MovableItem } from './DragAndDropComponent';
import Spinner from '../../CustomComponents/Spinner';
import BreadCrumbComponent from '../../CustomComponents/BreadCrumbComponent';
import { CloseOutlined, WarningOutlined } from '@ant-design/icons';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';

const KeyToPhrase = () => {
  const history = useHistory();
  const [theme] = useSelector(state => [state.themeReducer]);
  const [searchString, setSearchString] = useState('');
  const [total, setTotal] = useState(0);
  const [initialRender, setInitialRender] = useState(true);
  const [fetchDataFlagMine, setFetchDataFlagMine] = useState(true);
  const [fetchDataFlagAuthor, setFetchDataFlagAuthor] = useState(true);
  const [fetchDataFlagActive, setFetchDataFlagActive] = useState(true);
  const [cannedText, setCannedTexts] = useState([]);
  const [cannedTextAuthor, setCannedTextsAuthor] = useState([]);
  const [cannedTextActive, setCannedTextsActive] = useState([]);
  const [cannedTextMine, setCannedTextsMine] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [k2pMapping, setK2pMapping] = useState([]);
  const [cannedTextMineSize, setCannedTextsMineSize] = useState(0);
  const [cannedTextAuthorSize, setCannedTextAuthorSize] = useState(0);
  const [cannedTextActiveSize, setCannedTextActiveSize] = useState(0);
  const [checkedCards, setCheckedCards] = useState([]);
  const [dynamicEndPoints, setDynamicEndPoints] = useState([]);
  const [showTable, setShowTable] = useState(true);
  const [toActive, setToActive] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [templateMappingModified, setTemplateMappingModified] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [checkedCardIds, setCheckedCardIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTree, setLoadingTree] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingActiveScroll, setLoadingActiveScroll] = useState(false);
  const [loadingMineScroll, setLoadingMineScroll] = useState(false);
  const [loadingAuthor, setLoadingAuthor] = useState(false);
  const [addDrawerVisible, setAddDrawerVisible] = useState(false);
  const [exportToOtherAuthors, setExportToOtherAuthors] = useState(false);
  const [active, setActive] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [treeVisible, setTreeVisible] = useState(
    selectedItem ? selectedItem.restrictedToTemplates : false
  );
  const user = useSelector(state => state.userReducer);
  const [selectedItemColumn, setSelectedItemColumn] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [filterKey, setFilterKey] = useState('name');
  const [sortOrder, setSortOrder] = useState('');
  const [facilityIds, setFacilityIds] = useState();
  const [overRideExisting, setOverRideExisting] = useState(false);
  const [facilities, setFacilities] = useState([]);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { Option } = StyledSelect;
  const toggleTable = () => {
    setK2pMapping([]);
    setShowSelectedPhrase(false);
    setSelectedItem(null);
  };
  const handleCreate = () => {
    setK2pMapping([]);
    fetchAll();
    setSelectedItem(null);
    setShowSelectedPhrase(true);
    if (!selectedItem) {
      setTreeVisible(false);
    }
  };
  const [minePage, setMinePage] = useState(0);
  // const [minePageSearch, setMinePageSearch] = useState(0);
  // Active/Inactive filter for the merged list: 'all' | 'active' | 'inactive'
  const [listFilter, setListFilter] = useState('all');
  // Client-side search text (filters the already-loaded list, no API call)
  const [searchText, setSearchText] = useState('');
  const [pendingFlips, setPendingFlips] = useState({});
  const [searchQueryAuthor, setSearchQueryAuthor] = useState('');
  // const [cannedTextMineSearch, setCannedTextsMineSearch] = useState([]);
  // const [cannedTextsMineSearchSize, setCannedTextsMineSearchSize] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [authPage, setAuthPage] = useState(0);
  const [keyToPhraseItems, setKeyToPhraseItems] = useState([]);
  const [selectedFacilityItem, setSelectedFacilityItem] = useState([]);
  const [showSelectedPhrase, setShowSelectedPhrase] = useState(false);
  const [selectedPhrase, setSelectedPhrase] = useState();
  const { KEY_TO_PHRASE, ACTIVE_KEY_TO_PHRASE } = COLUMN_NAMES;
  const [loader, setLoader] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [templateSections, setTemplateSections] = useState([]);
  const [usageModalVisible, setUsageModalVisible] = useState(false);
  const [usageModalK2p, setUsageModalK2p] = useState('');
  const [usageModalItems, setUsageModalItems] = useState([]);
  const [deleteWarningVisible, setDeleteWarningVisible] = useState(false);
  const [deleteWarningItems, setDeleteWarningItems] = useState([]);
  const [deleteWarningForAllUsers, setDeleteWarningForAllUsers] = useState(false);
  // const [hasMore, setHasMore] = useState(true); // State to indicate if there are more items to load
  // const [items, setItems] = useState([]); // State to hold the items
  // const [data, setData] = useState([]); // State to hold fetched data
  let appendedData = [];
  const handleMineDelete = () => {
    if (!selectedItem) return;
    const usedIn = templateSections.filter(s =>
      s.defaultValue.includes(selectedItem.key)
    );
    if (usedIn.length > 0) {
      setDeleteWarningItems(usedIn);
      setDeleteWarningVisible(true);
    } else {
      setDeleteModal(true);
    }
  };
  const toggleActive = () => {
    setToActive(!toActive);
    setDeleteModal(false);
  };
  const handleFormValuesChange = (changedValues, allValues) => {
    if (selectedItem) {
      for (const key in changedValues) {
        if (typeof changedValues[key] === 'string') {
          if (selectedItem[key] !== null) {
            if (
              removeHTMLTags(selectedItem[key]) !==
              removeHTMLTags(changedValues[key])
            ) {
              setSubmitDisabled(true);
            } else {
              setSubmitDisabled(false);
            }
          }
        } else {
          if (selectedItem[key] !== null) {
            if (selectedItem[key] !== changedValues[key]) {
              setSubmitDisabled(true);

              // Perform any action you want upon detecting a change to the same value
            } else {
              setSubmitDisabled(false);
            }
          }
        }
      }
    }
  };
  useEffect(() => {
    if (!initialRender) {
      if (authPage === 0 && fetchDataFlagAuthor) {
        setFetchDataFlagAuthor(false);

        fetchAuthorData();
      }
    } else {
      setInitialRender(false);
    }
  }, [searchQueryAuthor, fetchDataFlagAuthor, authPage, cannedTextAuthor]);
  let timerId1;

  // Client-side search over the already-loaded global (author) collection.
  const handleSearchAuthor = event => {
    setSearchQueryAuthor(event.target.value);
  };

  const handleOpenModal = (e, id) => {
    e.stopPropagation(); // Stop event propagation to prevent triggering the parent click event
    const removeItem = cannedTextActive.find(item => item.id === id);
    setSelectedItem(removeItem);
    setIsModalVisible(true);
  };
  // Function to handle confirming the action and closing the modal
  const handleConfirmAction = e => {
    handleRemoveFromSelected(e, selectedItem.id);
  };

  // Function to handle canceling the action and closing the modal
  const handleCancelAction = () => {
    setIsModalVisible(false);
  };

  const moveCardHandler = (dragIndex, hoverIndex) => {
    const dragItem = cannedTextMine[dragIndex];

    if (dragItem) {
      setKeyToPhraseItems(prevState => {
        const coppiedStateArray = [...prevState];
        const prevItem = coppiedStateArray.splice(hoverIndex, 1, dragItem);

        coppiedStateArray.splice(dragIndex, 1, prevItem[0]);

        return coppiedStateArray;
      });
    }
  };
  const KeyPhraseCard = ({
    id,
    facilityKey,
    phrase,
    cardClosable = false,
    handleItemClick
  }) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <StyledDiv
          width='100%'
          className='movable-item1'
          direction='column'
          onClick={handleItemClick}
        >
          <StyledDiv width='100%' justify={'space-between'}>
            <h4 className='keyvalue'>
              <TruncatedText text={facilityKey} maxLength={80} />
            </h4>
            {cardClosable && (
              <CloseButton
                onClick={e => handleOpenModal(e, id)}
                icon={<CloseOutlined />}
              />
            )}

            <ConfirmationModal
              visible={isModalVisible}
              onOk={e => handleConfirmAction(e)}
              onCancel={handleCancelAction}
              // maskStyle={{ backgroundColor: 'transparent' }}

              centered
              // loading={deleteLoading}
              confirmation={true}
              antdModalProps={{ closable: false, mask: false }}
            >
              <DeleteIcon />
              <DeleteConfirmationMessage>
                Are you sure you want to delete?
              </DeleteConfirmationMessage>
            </ConfirmationModal>
          </StyledDiv>
          <p className='phrasevalue'>
            <TruncatedText text={removeHTMLTags(phrase)} maxLength={100} />
          </p>
        </StyledDiv>
      </div>
    );
  };
  useEffect(() => {}, [loadingTree]);
  let updatedK2pMappingkeys = [];
  const toggleTreeVisibility = (newValue, templateMapping) => {
    setLoadingTree(true);
    if (newValue === true) {
      templateMappingStatus()
        .then(response => {
          if (response.data.success) {
            if (templateMapping) {
              templateMapping.forEach(templateItem => {
                const k2pItemIndex = response.data.result.findIndex(
                  item => item.id === templateItem.templateId
                );

                if (k2pItemIndex !== -1) {
                  response.data.result[k2pItemIndex].selected =
                    templateItem.allHeadings;
                  if (templateItem.allHeadings !== true) {
                    response.data.result[k2pItemIndex].sectionHeadings.forEach(
                      sectionHeading => {
                        if (
                          templateItem.templateHeadings.includes(
                            sectionHeading.customUIHeading
                          )
                        ) {
                          sectionHeading.selected = true;
                        }
                      }
                    );
                  } else {
                    response.data.result[k2pItemIndex].sectionHeadings.map(
                      sectionHeading => {
                        sectionHeading.selected = true;
                      }
                    );
                  }
                }
              });
            }

            let updatedK2pMapping = response.data.result.map(
              (template, templateIndex) => {
                template.sectionHeadings = template.sectionHeadings.map(
                  (heading, headingIndex) => {
                    // Generate the key
                    const id = `0-${templateIndex}-${headingIndex}`;

                    // Set the key to the sectionHeading
                    if (heading.selected) {
                      updatedK2pMappingkeys.push(id);
                    }
                    return { ...heading, id };
                  }
                );

                return template;
              }
            );

            setK2pMapping(updatedK2pMapping);
            setLoadingTree(false);

            // notification['success']({
            //   message: 'Success',
            //   description: response.data.message
            // });
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
          }
        })

        .catch(error => {
          // Handle errors if needed
        });
      setTreeVisible(newValue);
    } else {
      setLoadingTree(false);
      setTreeVisible(newValue);
    }
  };

  const handleRemoveFromSelected = (e, id) => {
    e.stopPropagation();
    // setIsModalVisible(true);
    removeCannedTextActiveList(id).then(res => {
      if (res?.data?.success) {
        notification.success({ message: res?.data?.message });
        setShowSelectedPhrase(false);
        setIsModalVisible(false);
        const data = cannedTextActive.filter(item => item.id !== id);
        setCannedTextsActive(data);
        const removedItem = cannedTextActive.find(item => item.id === id);

        removedItem.active = false;
        setCannedTextsMine(prevItems => [removedItem, ...prevItems]);
        // setFetchDataFlagMine(true);
        setMinePage(0);

        // fetchMineData();
        setActivePage(0);
        // fetchActiveData();
        // fetchData();
      } else {
        notification.error({ message: res?.data?.message });
      }
    });
  };

  const saveCannedTextToFacility = item => {
    saveCannedTextActiveList(item.data.id).then(res => {
      if (res?.data?.success) {
        notification.success({ message: res?.data?.message });

        const data = cannedTextMine.filter(
          cannedItem => cannedItem.id !== item.data.id
        );
        setCannedTextsMine(data);

        setMinePage(0);

        setActivePage(0);
        // setActivePage(0);
        // fetchActiveData();
        // setCannedTextsMine(data);
      } else {
        notification.error({ message: res?.data?.message });
      }
    });
  };

  const returnItemsForColumn = columnName => {
    return cannedTextActive.map((item, index) => (
      <KeyPhraseCard
        key={index}
        id={item.id}
        facilityKey={item.key}
        phrase={item.phrase}
        cardClosable={true}
        handleItemClick={() => handleItemClick(item, 'Active')}
        saveCannedTextToFacility={() => saveCannedTextToFacility()}
        style={{ backgroundColor: 'white' }}
      />
    ));
  };

  const TruncatedText = ({ text, maxLength }) => {
    if (typeof text === 'string' && text.length > maxLength) {
      const truncatedText = text.substring(0, maxLength) + '...';
      return <span>{truncatedText}</span>;
    }
    return <span>{text}</span>;
  };
  const handleActiveClickChange = () => {
    submitHandler();
  };

  useEffect(() => {
    let newSelectedFields = [];

    k2pMapping
      .filter(item => {
        return item.selected;
      })
      .filter(item => {
        return item.selected;
      })
      .forEach(item => {
        newSelectedFields.push(item);
      });

    k2pMapping
      .filter(item => {
        return (
          item.selected === false &&
          item.sectionHeadings.some(heading => heading.selected)
        );
      })
      .forEach(item => {
        item.sectionHeadings
          .filter(subItem => {
            return subItem.selected;
          })
          .forEach(subItem => {
            newSelectedFields.push(subItem);
          });
      });

    setSelectedFields(newSelectedFields);
  }, [k2pMapping]);
  const handleCheck = (checkedKeys, { node }) => {
    setSubmitDisabled(true);
    setTemplateMappingModified(true);

    setK2pMapping(
      k2pMapping.map(item => {
        if (item.id === node.key) {
          // Toggle selected for the entire item and its sectionHeadings
          item.sectionHeadings = item?.sectionHeadings?.map(subItem => {
            subItem.selected = !subItem.selected;
            return subItem;
          });
          item.selected = !item.selected;
        } else {
          item.sectionHeadings = item?.sectionHeadings?.map(subItem => {
            // Check if the subItem key matches node.key
            if (subItem.id === node.key) {
              // Toggle the selected property
              subItem.selected = !subItem.selected;
            }
            return subItem; // Ensure to return the modified subItem
          });
          if (item.sectionHeadings.some(heading => !heading.selected)) {
            item.selected = false;
          } else {
            item.selected = true;
          }
        }
        return item; // Ensure to return the modified item
      })
    );
  };

  const handleDeleteClick = (deleteFromOtherAuthors = false) => {
    setSubmitLoading(true);

    removeCannedTexts(selectedItem.id, deleteFromOtherAuthors)
      .then(response => {
        if (response.data.success) {
          notification['success']({
            message: 'Success',
            description: response.data.message
          });
          setDeleteModal(false);
          setDeleteWarningVisible(false);
          setDeleteWarningForAllUsers(false);
          setSubmitLoading(false);
          setShowSelectedPhrase(false);
          fetchData();
          if (selectedItem.active) {
            const data = cannedTextActive.filter(
              cannedItem => cannedItem.id !== selectedItem.id
            );

            setCannedTextsActive(data);
          } else {
            const data = cannedTextMine.filter(
              cannedItem => cannedItem.id !== selectedItem.id
            );

            setCannedTextsMine(data);
          }
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
          setDeleteModal(false);
          setDeleteWarningVisible(false);
          setDeleteWarningForAllUsers(false);
          setSubmitLoading(false);
          setShowSelectedPhrase(false);
        }
      })

      .catch(err => {
        setSubmitLoading(false);
        setDeleteWarningVisible(false);
        setDeleteWarningForAllUsers(false);
        console.log(err);
      });
  };
  const handleActivateToggleSave = active => {
    setSubmitLoading(true);
    const templateMapping = k2pMapping
      .map(item => {
        const allHeadings = item.selected;
        const templateHeadings = item.sectionHeadings
          .filter(heading => heading.selected)
          .map(heading => heading.customUIHeading);
        return {
          allHeadings,
          templateHeadings,
          templateId: item.id
        };
      })
      .filter(item => item.templateHeadings.length > 0);
    const payload = {
      active,
      id: selectedItem.id,
      restrictedToTemplates: treeVisible,
      templateMapping
    };
    exportedCannedText(payload)
      .then(res => {
        if (res?.data?.success) {
          notification.success({ message: res?.data?.message });
          setSubmitLoading(false);
          setSubmitDisabled(false);
          setTemplateMappingModified(false);
          setShowSelectedPhrase(false);
          setSelectedItem(null);
          setCannedTextsActive([]);
          setActivePage(0);
          setFetchDataFlagActive(true);
          setCannedTextsMine([]);
          setMinePage(0);
          setFetchDataFlagMine(true);
        } else {
          notification.error({ message: res?.data?.message });
          setSubmitLoading(false);
        }
      })
      .catch(() => setSubmitLoading(false));
  };
  const returnItemsForColumn1 = columnName => {
    return (
      cannedTextMine
        // .filter(item => item.column === columnName)
        .map((item, index) => {
          return (
            <MovableItem
              key={item.id}
              id={item.id}
              name={
                <StyledDiv direction='column'>
                  <h4 className='keyvalue'>
                    <TruncatedText text={item.key} maxLength={60} />
                  </h4>
                  <p className='phrasevalue'>
                    <TruncatedText
                      text={removeHTMLTags(item.phrase)}
                      maxLength={60}
                    />
                  </p>
                </StyledDiv>
              }
              currentColumnName={item.column}
              setItems={setCannedTextsActive}
              saveCannedTextToFacility={saveCannedTextToFacility}
              index={index}
              moveCardHandler={moveCardHandler}
              handleItemClick={() => handleItemClick(item, 'Mine')}
              data={item}
              className={columnName === 'Column1' ? 'column1-item' : ''}
            />
          );
        })
    );
  };

  // Activate / deactivate a key-to-phrase directly from the list toggle,
  // moving it between the active and inactive (mine) lists on success.
  const handleToggleActive = (item, checked) => {
    setPendingFlips(prev => ({ ...prev, [item.id]: checked }));

    const clearPending = () =>
      setPendingFlips(prev => {
        const next = { ...prev };
        delete next[item.id];
        return next;
      });

    const apiCall = checked
      ? saveCannedTextActiveList(item.id)
      : removeCannedTextActiveList(item.id);

    apiCall
      .then(res => {
        if (res?.data?.success) {
          notification.success({ message: res?.data?.message });
          if (checked) {
            setCannedTextsMine(prev => prev.filter(i => i.id !== item.id));
            setCannedTextsActive(prev => [{ ...item, active: true }, ...prev]);
          } else {
            setCannedTextsActive(prev => prev.filter(i => i.id !== item.id));
            setCannedTextsMine(prev => [{ ...item, active: false }, ...prev]);
          }
        } else {
          notification.error({ message: res?.data?.message });
        }
        clearPending();
      })
      .catch(() => {
        notification.error({ message: 'Something went wrong, please try again.' });
        clearPending();
      });
  };

  // Returns the list to display based on the Active/Inactive filter and the
  // client-side search text. Active items come from cannedTextActive, inactive
  // from cannedTextMine.
  const getVisibleList = () => {
    let list;
    if (listFilter === 'active') list = cannedTextActive;
    else if (listFilter === 'inactive') list = cannedTextMine;
    else list = [...cannedTextActive, ...cannedTextMine].sort((a, b) =>
      (a.key || '').localeCompare(b.key || '')
    );

    const query = searchText.trim().toLowerCase();
    if (!query) return list;

    return list.filter(item => {
      const key = (item.key || '').toLowerCase();
      const phrase = (removeHTMLTags(item.phrase) || '').toLowerCase();
      return key.includes(query) || phrase.includes(query);
    });
  };

  // Client-side filtered view of the global (author) collection for the
  // import modal search.
  const getAuthorList = () => {
    const query = (searchQueryAuthor || '').trim().toLowerCase();
    if (!query) return cannedTextAuthor;

    return cannedTextAuthor.filter(item => {
      const key = (item.key || '').toLowerCase();
      const phrase = (removeHTMLTags(item.phrase) || '').toLowerCase();
      return key.includes(query) || phrase.includes(query);
    });
  };

  // Renders the merged list of active + inactive (mine) key-to-phrases as flat
  // rows: key + phrase preview on the left; status, activate toggle and edit
  // button on the right.
  const returnMergedItems = () => {
    const mergedList = getVisibleList();

    return mergedList.map((item, index) => (
      <div
        key={item.id ?? index}
        className='k2p-row'
        onClick={() => handleItemClick(item, item.active ? 'Active' : 'Mine')}
      >
        <div className='k2p-row-info'>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div className='keyvalue'>
              <TruncatedText text={item.key} maxLength={60} />
            </div>
            {templateSections.some(s => s.defaultValue.includes(item.key)) ? (
              <Tag
                color='blue'
                style={{ borderRadius: 10, marginRight: 0, cursor: 'pointer' }}
                onClick={e => {
                  e.stopPropagation();
                  setUsageModalK2p(item.key);
                  setUsageModalItems(
                    templateSections.filter(s =>
                      s.defaultValue.includes(item.key)
                    )
                  );
                  setUsageModalVisible(true);
                }}
              >
                In use
              </Tag>
            ) : (
              <Tag color='default' style={{ borderRadius: 10, marginRight: 0 }}>
                Not used
              </Tag>
            )}
          </div>
          <div className='phrasevalue'>
            <TruncatedText text={removeHTMLTags(item.phrase)} maxLength={70} />
          </div>
        </div>

        <div className='k2p-row-actions'>
          {(item.id in pendingFlips ? pendingFlips[item.id] : item.active) ? (
            <Tag className='status-tag'>
              Active
            </Tag>
          ) : (
            <span className='status-inactive'>Inactive</span>
          )}
          <StatusSwitch
            checked={item.id in pendingFlips ? pendingFlips[item.id] : item.active}
            onClick={(checked, e) => e.stopPropagation()}
            onChange={checked => handleToggleActive(item, checked)}
          />
          <Button
            className='edit-btn'
            icon={<EditOutlined />}
            onClick={e => {
              e.stopPropagation();
              handleItemClick(item, item.active ? 'Active' : 'Mine');
            }}
          />
        </div>
      </div>
    ));
  };

  const handleSkip = () => {
    handleImport();
    // setCannedTextsAuthor([]);
    setAuthPage(0);
  };
  const handleReplace = () => {
    handleImport(true);
    // setCannedTextsAuthor([]);
    setAuthPage(0);
  };

  const submitHandler = values => {
    values.phrase = values.phrase
      .replace(/<\/p>/g, '</p><br>')
      .replace(/<p><br><\/p><br>/g, '<br>')
      .replace(/<br>$/g, '');
    values.targetEndPoint =
      values.targetEndPoint === '' || values.dynamic == false
        ? null
        : values.targetEndPoint;
    // values.exportToOtherAuthors = value.exportToOtherAuthors;
    values.templateMapping = k2pMapping
      .map(item => {
        const allHeadings = item.selected;
        const templateHeadings = item.sectionHeadings
          .filter(heading => heading.selected)
          .map(heading => heading.customUIHeading);
        return {
          allHeadings,
          templateHeadings,
          templateId: item.id
        };
      })
      .filter(item => item.templateHeadings.length > 0);
    setSubmitLoading(true);
    const payload = values;
    payload.defaultValue =
      values.dynamic && values.defaultValue ? String(values.defaultValue) : '';

    if (selectedItem) {
      payload.id = selectedItem.id;
      editCannedText(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Success',
              description: response.data.message
            });

            setSubmitLoading(false);
            setSubmitDisabled(false);

            const updatedItem = { ...selectedItem, ...payload };
            setSelectedItem(updatedItem);

            if (payload.active) {
              setCannedTextsActive(prev => {
                const idx = prev.findIndex(i => i.id === updatedItem.id);
                if (idx !== -1) {
                  const next = [...prev];
                  next[idx] = updatedItem;
                  return next;
                }
                return [...prev, updatedItem];
              });
              setCannedTextsMine(prev =>
                prev.filter(i => i.id !== updatedItem.id)
              );
            } else {
              const mineItem = {
                ...updatedItem,
                column: COLUMN_NAMES.KEY_TO_PHRASE
              };
              setCannedTextsMine(prev => {
                const idx = prev.findIndex(i => i.id === mineItem.id);
                if (idx !== -1) {
                  const next = [...prev];
                  next[idx] = mineItem;
                  return next;
                }
                return [...prev, mineItem];
              });
              setCannedTextsActive(prev =>
                prev.filter(i => i.id !== updatedItem.id)
              );
            }
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
            // setShowSelectedPhrase(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    } else {
      saveCannedText(payload)
        .then(response => {
          if (response.data.success) {
            notification['success']({
              message: 'Success',
              description: response.data.message
            });
            setSubmitLoading(false);
            toggleTable(false);
            setSelectedItem(null);
            // fetchMineData();
            setCannedTextsMine([]);
            setCannedTextsMineSize(0);
            setMinePage(0);
            setFetchDataFlagMine(true);
            setCurrentPage(0);
            setCannedTextsActive([]);
            setCannedTextActiveSize(0);
            setActivePage(0);
            setFetchDataFlagActive(true);
          } else {
            notification['error']({
              message: 'Failed',
              description: response.data.message
            });
            setSubmitLoading(false);
            // toggleTable(false);
          }
        })
        .catch(err => {
          setSubmitLoading(false);
          console.log(err);
        });
    }
  };
  const handleActiveChange = e => {
    setActive(e.target.checked);
  };

  const handleExportChange = e => {
    setExportToOtherAuthors(e.target.checked);
  };
  const fetchAll = pageNo => {
    // setLoading(true);
    targetEndPoints()
      .then(response => {
        setLoading(false);
        if (response.data.success) {
          setTotal(response.data.size);
          setCannedTexts(response.data.result);
          setDynamicEndPoints(response.data.result);
          const keys = response.data.result.map(item => {
            return { ...item, column: COLUMN_NAMES.KEY_TO_PHRASE };
          });

          setKeyToPhraseItems(keys);
        } else {
          notification['error']({
            message: 'Failed',
            description: response.data.message
          });
        }
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };

  const filterTableChange = (pagination, filters, sorter) => {
    if (sorter.field !== undefined)
      setFilterKey(sorter.field && sorter.field[0]);
    if (sorter.order !== undefined) setSortOrder(sorter.order);
  };

  const onChangeHandler = value => {
    setCurrentPage(0);
    setSearchString(value);
  };

  const debounceOnChange = useCallback(
    useDebounce(onChangeHandler, SEARCH_DELAY),
    []
  );

  // const pageNoChangeHandler = pageNo => {
  //   fetchAll(pageNo);
  // };
  const handleItemClick = (item, type) => {
    if (!item.editable) {
      notifyNotEditable();
    }
    setTemplateMappingModified(false);
    setToActive(false);
    fetchAll();
    setSelectedItemColumn(type);
    setSelectedItem(item);
    updatedK2pMappingkeys = [];
    toggleTreeVisibility(
      item && item.restrictedToTemplates,
      item && item.templateMapping
    );

    if (!isModalVisible) {
      setShowSelectedPhrase(true);
    }
  };
  const handleCancel = () => {
    setModalVisible(false);
    setSelectedCard(null);
    setSearchQueryAuthor('');
    setCannedTextsAuthor([]);
    setAuthPage(0);
    setCheckedCards([]);
    setCheckedCards([]);
  };
  const toggleErrorModal = () => {
    setErrorModalVisible(!errorModalVisible);
    // setCannedTextsAuthor([]);
    setAuthPage(0);
  };
  const activeItems = returnItemsForColumn(ACTIVE_KEY_TO_PHRASE);
  // fetchAllCannedText = () => {};
  const getFacilities = () => {
    getUserFacilities().then(response => {
      if (response.data.success) {
        const enabledFacilities = response.data.result.filter(facility => {
          return !facility.disabled;
        });
        setFacilities(enabledFacilities);
        setFacilityIds(enabledFacilities[0]?.facilityId);
      } else {
        notification['error']({
          message: 'User Facilities Fetch Failed',
          description: response.data.message
        });
      }
    });
  };
  // Fetches the whole global (author) collection in one call, no pagination.
  const fetchAuthorData = async () => {
    setFetchDataFlagAuthor(false);

    setModalVisible(true);
    setLoadingAuthor(true);

    try {
      const res = await getAllCannedText('author');
      setCannedTextsAuthor(res?.data?.result || []);
      setLoadingAuthor(false);
    } catch (error) {
      setLoadingAuthor(false);
    }
  };

  // Fetches all key-to-phrases (active + inactive) in one call, no pagination,
  // then splits them into the active and mine (inactive) lists by their flag.
  const fetchAllK2p = async () => {
    try {
      const res = await getAllCannedText('allMine');
      const items = res?.data?.result || [];

      setCannedTextsActive(items.filter(item => item.active));
      setCannedTextsMine(
        items
          .filter(item => !item.active)
          .map(item => ({ ...item, column: COLUMN_NAMES.KEY_TO_PHRASE }))
      );
      setLoading(false);
      setLoadingActive(false);
    } catch (error) {
      setLoading(false);
      setLoadingActive(false);
    }
  };

  useEffect(() => {}, [cannedTextAuthor]);
  useEffect(() => {
    if (fetchDataFlagMine || fetchDataFlagActive) {
      setLoading(true);
      fetchAllK2p();
      setFetchDataFlagMine(false);
      setFetchDataFlagActive(false);
    }
  }, [fetchDataFlagMine, fetchDataFlagActive]);

  useEffect(() => {
    const fetchTemplateSections = async () => {
      try {
        const res = await listDictationTemplate('allMine');
        const templates = res?.data?.result || [];
        const sections = [];
        templates.forEach(template => {
          (template.sectionHeadings || []).forEach(section => {
            if (section.defaultValue) {
              sections.push({
                templateId: template.id,
                templateName: template.templateName,
                headingName: section.customUIHeading,
                defaultValue: section.defaultValue.replace(/<[^>]*>/g, '')
              });
            }
          });
        });
        setTemplateSections(sections);
      } catch (_) {}
    };
    fetchTemplateSections();
  }, []);

  const fetchData = () => {};

  function removeHTMLTags(inputString) {
    if (inputString) {
      return inputString.replace(/<[^>]*>/g, '');
    }
  }
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const isConflict = () => {
    const isItemAlreadyPresent = checkedCardIds.some(cardId => {
      const card = cannedTextAuthor.find(item => item.id === cardId);
      return card && card.conflict === true;
    });

    if (isItemAlreadyPresent) {
      toggleErrorModal();
      return;
    } else {
      // setCannedTextsAuthor([]);
      handleImport();
    }
  };
  const handleImport = (overRideExisting = false) => {
    authorsCollectionToMyCollection(
      checkedCardIds,
      overRideExisting,
      active,
      exportToOtherAuthors
    ).then(res => {
      if (res?.data?.success) {
        notification.success({ message: res?.data?.message });
        setModalVisible(false);
        setCheckedCards([]);
        setCheckedCardIds([]);
        setSelectedCard(null);
        setErrorModalVisible(false);
        setCannedTextsMine([]);
        setCannedTextsMineSize(0);
        setMinePage(0);
        setFetchDataFlagMine(true);
        setCannedTextsActive([]);
        setCannedTextActiveSize(0);
        setActivePage(0);
        setFetchDataFlagActive(true);
        // fetchMineData();
        setActive(false);
        setExportToOtherAuthors(false);
      } else {
        notification.error({ message: res?.data?.message });
        setActive(false);
        setExportToOtherAuthors(false);
      }
    });
  };
  const phraseWithoutPTags =
    selectedCard && selectedCard.phrase
      ? selectedCard.phrase
          .replace(/<p><br><\/p><br>/g, '<p>') // Replace <br><p> with <p>
          .replace(/<p>/g, '') // Remove <p> tags
          .replace(/<\/p>/g, '') // Remove </p> tags
      : '';

  useEffect(() => {
    setSelectedCard(cannedTextAuthor[0]);
  }, [cannedTextAuthor]);

  useEffect(() => {}, [cannedTextAuthor]);
  const fetchCannedTexts = type => {};
  const handleCardClick = card => {
    setSelectedCard(card);
  };
  const removeSpaces = str => {
    // Remove all spaces from a string
    return str.replace(/\s/g, '');
  };
  const handleCheckboxChange = (card, checked) => {
    if (checked) {
      const similarKeyItem = checkedCards.find(
        item => removeSpaces(item.key) === removeSpaces(card.key)
      );
      if (similarKeyItem) {
        message.error('This card is already checked!');
      } else {
        setCheckedCards([...checkedCards, card]);
      }
    } else {
      // If the checkbox is unchecked, remove the item from the checkedCards array
      setCheckedCards(checkedCards.filter(item => item.id !== card.id));
    }
    if (checkedCardIds.includes(card.id)) {
      setCheckedCardIds(checkedCardIds.filter(id => id !== card.id));
    } else {
      setCheckedCardIds([...checkedCardIds, card.id]);
    }
  };
  return (
    <>
      <PageTitle title='Key to Phrase' />
      <ContainerRow
        device={true}
        style={{ flexWrap: 'nowrap', overflow: 'hidden' }}
      >
        <TitleRow justify='space-between' style={{ position: 'relative' }}>
          <NavTabs
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)'
            }}
          >
            <NavTab
              onClick={() => history.push('/dashboard/settings/template-list')}
            >
              Templates
            </NavTab>
            <NavTab active={true}>Key to phrase</NavTab>
          </NavTabs>
          <div style={{ marginLeft: 'auto' }}>
            <K2pButtonsecnd
              className='blue-button'
              shape='round'
              onClick={fetchAuthorData}
              icon={<ArrowDownOutlined className='blue-button' />}
            >
              Import From Global List
            </K2pButtonsecnd>

            <CustomModal
              title='Import Key-to-Phrases'
              className='customModalTitle'
              visible={modalVisible}
              onCancel={handleCancel}
              bodyStyle={{}}
              // footer={[
              //   <AddButton key='cancel' shape='round' onClick={handleCancel}>
              //     Cancel
              //   </AddButton>,
              //   <AddButton
              //     key='import'
              //     type='primary'
              //     icon={<DownloadOutlined />}
              //     shape='round'
              //     onClick={isConflict}
              //     disabled={!checkedCards || checkedCards.length === 0}
              //   >
              //     Import selected
              //   </AddButton>
              // ]}
              footer={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: '8px',
                    marginBottom: '8px'
                  }}
                >
                  {/* ✅ Checkboxes side-by-side */}
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <Checkbox checked={active} onChange={handleActiveChange}>
                      <strong>Import as Active</strong>
                    </Checkbox>
                    {(user.userType === 'admin' ||
                      user.userType === 'clinicAdmin') && (
                      <Checkbox
                        checked={exportToOtherAuthors}
                        onChange={handleExportChange}
                      >
                        <strong>Activate for all users</strong>
                      </Checkbox>
                    )}
                  </div>

                  {/* ✅ Footer buttons */}
                  <div>
                    <AddButton
                      key='cancel'
                      shape='round'
                      onClick={handleCancel}
                    >
                      Cancel
                    </AddButton>
                    <AddButton
                      key='import'
                      type='primary'
                      icon={<DownloadOutlined />}
                      shape='round'
                      onClick={isConflict}
                      style={{ marginLeft: '8px' }}
                    >
                      Import selected
                    </AddButton>
                  </div>
                </div>
              }
            >
              <Row gutter={[16, 16]} style={{ marginRight: '2px' }}>
                <Col span={9}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative'
                    }}
                  >
                    <SearchInputStylee
                      placeholder='Search Keys or Phrases'
                      prefix={<SearchOutlined />}
                      // value={searchQueryAuthor}
                      onChange={handleSearchAuthor}
                      style={{
                        marginBottom: '10px'
                      }}
                    />
                    <SearchDivider></SearchDivider>

                    {loadingAuthor ? (
                      <Spinner height={'52vh'} />
                    ) : getAuthorList().length === 0 ? (
                      <div
                        className='noData'
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flex: 1
                        }}
                      >
                        No data available
                      </div>
                    ) : (
                      <div
                        style={{
                          maxHeight: '440px',
                          overflowY: 'auto',
                          marginLeft: '19px'
                        }}
                      >
                        {getAuthorList().map(item => (
                          <KpCol
                            key={item.key}
                            onClick={() => handleCardClick(item)}
                            className='card-item'
                            // style={{ backgroundColor: '#f5f7fa ' }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '6px'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'baseline'
                                }}
                              >
                                <Checkbox
                                  checked={checkedCards.some(
                                    data => data.id === item.id
                                  )}
                                  onChange={e =>
                                    handleCheckboxChange(item, e.target.checked)
                                  }
                                />
                                <h3 className='keyvalue'>
                                  <TruncatedText
                                    text={item.key}
                                    maxLength={30}
                                  />
                                </h3>
                              </div>
                              <Tooltip
                                placement='topRight'
                                title={
                                  <div>
                                    <ExclamationCircleOutlined
                                      style={{ color: 'orange' }}
                                    />
                                    <span style={{ marginLeft: 8 }}>
                                      A K2P with this name already exist in your
                                      collection
                                    </span>
                                  </div>
                                }
                              >
                                {item.conflict && (
                                  <ExclamationCircleOutlined
                                    style={{
                                      color: '#E17F37',
                                      marginLeft: 'auto'
                                    }}
                                  />
                                )}
                              </Tooltip>
                            </div>
                            <div className='author-box'>
                              By: {item.author.doctorName}
                            </div>{' '}
                            <p style={{ marginBottom: '6px' }}>
                              <TruncatedText
                                text={removeHTMLTags(item.phrase)}
                                maxLength={30}
                              />
                            </p>
                          </KpCol>
                        ))}
                      </div>
                    )}
                  </div>
                  <Divider
                    type='vertical'
                    style={{
                      height: '100%',
                      position: 'absolute',
                      right: 0,
                      top: 0
                    }}
                  />
                </Col>

                {/* Right column */}
                <Col
                  span={15}
                  style={{ backgroundColor: '#F5F7FA', height: '490px' }}
                >
                  {selectedCard && (
                    <>
                      <Row gutter={[16, 16]}>
                        <Col span={24} style={{ marginTop: '12px' }}>
                          <h5
                            className='header'
                            style={{
                              marginLeft: 8,
                              fontFamily: 'Krub',
                              fontWeight: 400,
                              fontSize: '14px'
                            }}
                          >
                            Key
                          </h5>
                          <h2 className='detailedheadervalue'>
                            {selectedCard.key}
                          </h2>
                        </Col>
                        <Col
                          span={24}
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                          }}
                        ></Col>
                      </Row>
                      <Divider style={{ margin: '16px 0' }} />
                      <Row gutter={[16, 16]}>
                        <Col span={24}>
                          <h5>Phrase</h5>
                          {/* <p>{selectedCard.phrase}</p> */}
                          <div
                            style={{
                              width: '100%',
                              minHeight: '325px',
                              border: 'none !important',

                              padding: '5px',
                              overflowY: 'auto',
                              whiteSpace: 'pre-wrap' // Allow text to wrap
                            }}
                            contentEditable={false} // Set to true if you want to allow editing
                            dangerouslySetInnerHTML={{
                              __html: phraseWithoutPTags
                            }} // Render HTML content
                          />
                        </Col>

                        {/* <Col span={24}>
                          <Checkbox
                            checked={active}
                            onChange={handleActiveChange}
                          >
                            Import as Active
                          </Checkbox>
                          <br />
                          {(user.userType === 'admin' ||
                            user.userType === 'clinicAdmin') && (
                            <Checkbox
                              checked={exportToOtherAuthors}
                              onChange={handleExportChange}
                            >
                              Activate for all users
                            </Checkbox>
                          )}
                        </Col> */}
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
            </CustomModal>

            <Keytophraseduplication
              title='Import Key-to-Phrases'
              visible={errorModalVisible}
              onCancel={toggleErrorModal}
              footer={null}
              centered
            >
              <div style={{ flex: 1, marginBottom: '20px' }}>
                The names of certain key-to-phrases you are attempting to import
                are already present in your collection. Please choose whether to
                skip or replace the conflicting key-to-phrases.
              </div>
              <div
                className='warning-container'
                style={{ marginBottom: '20px' }}
              >
                <ExclamationCircleOutlined style={{ color: 'orange' }} />
                <div className='warning-message'>
                  Replacing will permanently remove those key-to-phrases from
                  your Collection
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '10px'
                }}
              >
                <AddButton
                  type='primary'
                  shape='round'
                  onClick={toggleErrorModal}
                >
                  Change selection
                </AddButton>
                <AddButton shape='round' onClick={handleSkip}>
                  Skip those
                </AddButton>
                <Button danger shape='round' onClick={handleReplace}>
                  Replace those
                </Button>
              </div>
            </Keytophraseduplication>

            <CustomModal
              title={`"${usageModalK2p}" — used in templates`}
              visible={usageModalVisible}
              onCancel={() => setUsageModalVisible(false)}
              centered
              footer={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '4px 0'
                  }}
                >
                  <Button
                    shape='round'
                    onClick={() => setUsageModalVisible(false)}
                  >
                    Close
                  </Button>
                </div>
              }
            >
              <div
                style={{ padding: '20px 24px', height: 400, overflowY: 'auto' }}
              >
                {usageModalItems.length === 0 ? (
                  <div
                    style={{
                      textAlign: 'center',
                      padding: '24px 0',
                      color: '#888'
                    }}
                  >
                    This K2P is not used in any template.
                  </div>
                ) : (
                  (() => {
                    const grouped = {};
                    usageModalItems.forEach(s => {
                      if (!grouped[s.templateName])
                        grouped[s.templateName] = {
                          templateId: s.templateId,
                          headings: []
                        };
                      grouped[s.templateName].headings.push(s.headingName);
                    });
                    const templateNames = Object.keys(grouped);
                    return (
                      <>
                        <div
                          style={{
                            marginBottom: 16,
                            fontSize: 13,
                            color: '#666'
                          }}
                        >
                          Used in{' '}
                          <span style={{ fontWeight: 600, color: '#1890ff' }}>
                            {templateNames.length}
                          </span>{' '}
                          template{templateNames.length !== 1 ? 's' : ''}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10,
                            paddingRight: 4
                          }}
                        >
                          {templateNames.map((name, i) => (
                            <div
                              key={i}
                              style={{
                                borderRadius: 8,
                                border: '1px solid #e8e8e8',
                                borderLeft: '4px solid #1890ff',
                                padding: '12px 16px',
                                background: '#fafafa'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  marginBottom: grouped[name].headings.length
                                    ? 8
                                    : 0
                                }}
                              >
                                <span
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 14,
                                    color: '#2b2b2b'
                                  }}
                                >
                                  {name}
                                </span>
                                <Button
                                  size='small'
                                  shape='round'
                                  icon={<EditOutlined />}
                                  onClick={() => {
                                    setUsageModalVisible(false);
                                    history.push(
                                      '/dashboard/settings/template-list',
                                      {
                                        openTemplateId: grouped[name].templateId
                                      }
                                    );
                                  }}
                                >
                                  View / Edit
                                </Button>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: 6
                                }}
                              >
                                {grouped[name].headings.map((heading, j) => (
                                  <Tag
                                    key={j}
                                    style={{
                                      borderRadius: 10,
                                      fontSize: 12,
                                      margin: 0,
                                      color: '#555'
                                    }}
                                  >
                                    {heading}
                                  </Tag>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    );
                  })()
                )}
              </div>
            </CustomModal>

            <CustomModal
              title='This K2P is in use — confirm deletion'
              visible={deleteWarningVisible}
              onCancel={() => { setDeleteWarningVisible(false); setDeleteWarningForAllUsers(false); }}
              centered
              footer={
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 0' }}>
                  {(user.userType === 'admin' || user.userType === 'clinicAdmin') ? (
                    <Checkbox
                      checked={deleteWarningForAllUsers}
                      onChange={e => setDeleteWarningForAllUsers(e.target.checked)}
                    >
                      <strong>Delete for all users</strong>
                    </Checkbox>
                  ) : <span />}
                  <div style={{ display: 'flex', gap: 8 }}>
                    <Button
                      shape='round'
                      onClick={() => { setDeleteWarningVisible(false); setDeleteWarningForAllUsers(false); }}
                    >
                      Cancel
                    </Button>
                    <Button
                      shape='round'
                      danger
                      loading={submitLoading}
                      onClick={() => {
                        handleDeleteClick(deleteWarningForAllUsers);
                      }}
                    >
                      Delete anyway
                    </Button>
                  </div>
                </div>
              }
            >
              <div style={{ padding: '20px 24px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 10,
                    marginBottom: 16,
                    padding: '12px 14px',
                    background: '#fff7e6',
                    borderRadius: 8,
                    border: '1px solid #ffd591'
                  }}
                >
                  <WarningOutlined
                    style={{
                      color: '#fa8c16',
                      fontSize: 16,
                      marginTop: 2,
                      flexShrink: 0
                    }}
                  />
                  <span style={{ fontSize: 13, color: '#614700' }}>
                    <strong>"{selectedItem?.key}"</strong> is referenced in the
                    following templates. Are you sure you want to continue.
                  </span>
                </div>
                {(() => {
                  const grouped = {};
                  deleteWarningItems.forEach(s => {
                    if (!grouped[s.templateName])
                      grouped[s.templateName] = {
                        templateId: s.templateId,
                        headings: []
                      };
                    grouped[s.templateName].headings.push(s.headingName);
                  });
                  const templateNames = Object.keys(grouped);
                  return (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10,
                        maxHeight: 320,
                        overflowY: 'auto',
                        paddingRight: 4
                      }}
                    >
                      {templateNames.map((name, i) => (
                        <div
                          key={i}
                          style={{
                            borderRadius: 8,
                            border: '1px solid #e8e8e8',
                            borderLeft: '4px solid #fa8c16',
                            padding: '12px 16px',
                            background: '#fafafa'
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: 14,
                              color: '#2b2b2b',
                              marginBottom: grouped[name].headings.length
                                ? 8
                                : 0
                            }}
                          >
                            {name}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: 6
                            }}
                          >
                            {grouped[name].headings.map((heading, j) => (
                              <Tag
                                key={j}
                                style={{
                                  borderRadius: 10,
                                  fontSize: 12,
                                  margin: 0,
                                  color: '#555'
                                }}
                              >
                                {heading}
                              </Tag>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
            </CustomModal>
          </div>
        </TitleRow>
        <BreadCrumbComponent
          items={[
            { name: 'Settings', path: '/dashboard/settings' },
            { name: 'Key to Phrase' },
          ]}
        />

        <div>
          <Topdivide />
          <Row style={{ height: 'calc(100vh - 155px)' }}>
            <KeytophraseMineCol span={9} style={{ height: '100%' }}>
              <SubmitCol
                style={{ height: '100%' }}
                bodyStyle={{
                  height: '100%',
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                  padding: '24px 24px 8px 24px'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 12
                  }}
                >
                  <CardTitle style={{ margin: 0, paddingTop: 0 }}>
                    Key to Phrase
                  </CardTitle>
                  <K2pButton
                    icon={<PlusOutlined />}
                    type='primary'
                    shape='round'
                    onClick={handleCreate}
                    style={{ marginRight: 0 }}
                  >
                    Create New K2P
                  </K2pButton>
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    marginBottom: '10px',
                    width: '100%',
                    alignItems: 'center'
                  }}
                >
                  <SearchInputStyle
                    placeholder='Search keys and phrases'
                    prefix={<SearchOutlined />}
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                    allowClear
                    style={{ flex: 1 }}
                  />
                  <Segmented
                    value={listFilter}
                    onChange={value => setListFilter(value)}
                    options={[
                      { label: 'All', value: 'all' },
                      { label: 'Active', value: 'active' },
                      { label: 'Inactive', value: 'inactive' }
                    ]}
                  />
                </div>

                <Divider></Divider>
                <DnDColumn
                  style={{
                    flex: 1,
                    overflow: 'auto',
                    minHeight: 0,
                    maxHeight: 'none'
                  }}
                >
                  {loading || loadingActive ? (
                    <Spinner height={'70vh'} />
                  ) : getVisibleList().length === 0 ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 1 // Make this div occupy remaining space vertically
                      }}
                    >
                      No data available
                    </div>
                  ) : (
                    <div style={{ paddingBottom: '8px' }}>{returnMergedItems()}</div>
                  )}
                </DnDColumn>
              </SubmitCol>
            </KeytophraseMineCol>

            <ActiveSectionCol span={15} className='activesection' style={{ height: '100%' }}>
              <KeyToPhraseDetailPanel
                key={selectedItem?.id ?? 'new'}
                showSelectedPhrase={showSelectedPhrase}
                selectedItem={selectedItem}
                toggleTable={toggleTable}
                setSubmitDisabled={setSubmitDisabled}
                k2pMapping={k2pMapping}
                selectedItemColumn={selectedItemColumn}
                selectedPhrase={selectedPhrase}
                submitHandler={submitHandler}
                selectedFields={selectedFields}
                handleCheck={handleCheck}
                treeVisible={treeVisible}
                toggleTreeVisibility={toggleTreeVisibility}
                submitLoading={submitLoading}
                handleDeleteClick={handleDeleteClick}
                dynamicEndPoints={dynamicEndPoints}
                toggleActive={toggleActive}
                loadingTree={loadingTree}
                handleActiveClickChange={handleActiveClickChange}
                toActive={toActive}
                handleFormValuesChange={handleFormValuesChange}
                submitDisabled={submitDisabled}
                handleMineDelete={handleMineDelete}
                deleteModal={deleteModal}
                updatedK2pMappingkeys={updatedK2pMappingkeys}
                handleActivateToggleSave={handleActivateToggleSave}
                templateMappingModified={templateMappingModified}
              />
            </ActiveSectionCol>
          </Row>
        </div>
      </ContainerRow>
    </>
  );
};

export default KeyToPhrase;
